module.exports = __webpack_public_path__ + "static/media/user-detail.b8773654.svg";